import { useEffect, useState } from 'react';
import { IBrowser, injectBrowser } from './browser';
import { IContainer, injectContainer } from './container';
import { IFetcher, injectFetch } from './fetch';
import { IKVStorage, injectKVStorage } from './kvStorage';
import { injectTranslationStorage, ITranslationStorage } from './translationStorage';
import { injectZip, IZip } from './zip';

function _useStateInjector<T>(fetcher: Promise<T | null>): T | null {
    const [item, setItem] = useState<T | null>(null);

    useEffect(() => {
        if (item) {
            return;
        }
        fetcher
            .then(val => setItem(val))
            .catch(err => {
                throw err;
            });
    }, [setItem, fetcher]);

    return item;
}

export function useFetch(container: IContainer = injectContainer()): IFetcher | null {
    return _useStateInjector<IFetcher>(injectFetch(container));
}

export function useZip(container: IContainer = injectContainer()): IZip | null {
    return _useStateInjector<IZip>(injectZip(container));
}

export function useKVStorage(container: IContainer = injectContainer()): IKVStorage | null {
    return _useStateInjector<IKVStorage>(injectKVStorage(container));
}

export function useBrowser(container: IContainer = injectContainer()): IBrowser | null {
    return _useStateInjector<IBrowser>(injectBrowser(container));
}

export function useTranslationStorage(
    container: IContainer = injectContainer(),
): ITranslationStorage | null {
    return _useStateInjector<ITranslationStorage>(injectTranslationStorage(container));
}
